import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectAffiliatesUrl, selectClient, selectContentProvider } from '../../global-selectors';
import IdpSelectorAffiliates from '../../components/IdpSelectorAffiliates';
import { selectLoginUrl } from '../../queries/selectors/user';
import { selectMsoConfig } from '../../queries/selectors/mso';
import { connectRequest } from '../../utils/query';
import { getMsoConfigRequest } from '../../queries/mso';

const mapStateToProps = (state) => ({
  client: selectClient(state),
  contentProvider: selectContentProvider(state),
  loginURL: selectLoginUrl(state),
  affiliatesURL: selectAffiliatesUrl(state),
  msoConfig: selectMsoConfig(state),
});

const mapPropsToConfig = (props) => [
  getMsoConfigRequest(props),
]

export default compose(withRouter, connect(mapStateToProps), connectRequest(mapPropsToConfig))(IdpSelectorAffiliates)
